function encode(obj, pfx) {
  let k;
  let i;
  let tmp;
  let str = "";
  for (k in obj) {
    if ((tmp = obj[k]) !== void 0) {
      if (Array.isArray(tmp)) {
        for (i = 0; i < tmp.length; i++) {
          str && (str += "&");
          str += `${encodeURIComponent(k)}=${encodeURIComponent(tmp[i])}`;
        }
      } else {
        str && (str += "&");
        str += `${encodeURIComponent(k)}=${encodeURIComponent(tmp)}`;
      }
    }
  }
  return (pfx || "") + str;
}
function stringifySearchWith(stringify, parser) {
  function stringifyValue(val) {
    if (typeof val === "object" && val !== null) {
      try {
        return stringify(val);
      } catch (err) {
      }
    } else if (typeof val === "string" && typeof parser === "function") {
      try {
        parser(val);
        return stringify(val);
      } catch (err) {
      }
    }
    return val;
  }
  return (search) => {
    search = { ...search };
    if (search) {
      Object.keys(search).forEach((key) => {
        const val = search[key];
        if (typeof val === "undefined" || val === void 0) {
          delete search[key];
        } else if (Array.isArray(val)) {
          search[key] = val.map(stringifyValue);
        } else {
          search[key] = stringifyValue(val);
        }
      });
    }
    const searchStr = encode(search).toString();
    return searchStr ? `?${searchStr}` : "";
  };
}
const encodeSearch = stringifySearchWith(JSON.stringify, JSON.parse);
function bufferToHex(buffer) {
  return [...new Uint8Array(buffer)].map((b) => b.toString(16).padStart(2, "0")).join("");
}
function remove0x(hex) {
  return hex.startsWith("0x") ? hex.slice(2) : hex;
}
function isStandaloneBrowser() {
  return window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone;
}
var DappRequestType = /* @__PURE__ */ ((DappRequestType2) => {
  DappRequestType2["Auth"] = "Auth";
  DappRequestType2["SignMessage"] = "SignMessage";
  DappRequestType2["SignEvm"] = "SignEvm";
  DappRequestType2["SignCkbTx"] = "SignCkbTx";
  DappRequestType2["SignCotaNFT"] = "SignCotaNFT";
  DappRequestType2["SignCkbRawTx"] = "SignCkbRawTx";
  DappRequestType2["SignNostrEvent"] = "SignNostrEvent";
  DappRequestType2["EncryptNostrMessage"] = "EncryptNostrMessage";
  DappRequestType2["EvmWeb2Login"] = "EvmWeb2Login";
  DappRequestType2["DecryptNostrMessage"] = "DecryptNostrMessage";
  DappRequestType2["AuthMiniApp"] = "AuthMiniApp";
  DappRequestType2["SignMiniAppMessage"] = "SignMiniAppMessage";
  DappRequestType2["SignMiniAppEvm"] = "SignMiniAppEvm";
  return DappRequestType2;
})(DappRequestType || {});
var DappCommunicationType = /* @__PURE__ */ ((DappCommunicationType2) => {
  DappCommunicationType2["Popup"] = "popup";
  DappCommunicationType2["Redirect"] = "redirect";
  return DappCommunicationType2;
})(DappCommunicationType || {});
const internalConfig = {
  joyidAppURL: "https://testnet.joyid.dev"
};
const getConfig$1 = () => internalConfig;
const JOYID_REDIRECT = "joyid-redirect";
const buildJoyIDURL = (request, type, path) => {
  const joyidURL = request.joyidAppURL ?? getConfig$1().joyidAppURL;
  const url = new URL(`${joyidURL}`);
  url.pathname = path;
  let redirectTo = request.redirectURL;
  if (type === "redirect") {
    const redirectURL = new URL(redirectTo);
    redirectURL.searchParams.set(JOYID_REDIRECT, "true");
    redirectTo = redirectURL.href;
  }
  url.searchParams.set("type", type);
  const data = encodeSearch({
    ...request,
    redirectURL: redirectTo
  });
  url.searchParams.set("_data_", data);
  return url.href;
};
class GenericError extends Error {
  constructor(error, error_description) {
    super(error_description);
    this.error = error;
    this.error_description = error_description;
    Object.setPrototypeOf(this, GenericError.prototype);
  }
  static fromPayload({
    error,
    error_description
  }) {
    return new GenericError(error, error_description);
  }
}
class TimeoutError extends GenericError {
  constructor() {
    super("timeout", "Timeout");
    Object.setPrototypeOf(this, TimeoutError.prototype);
  }
}
class PopupTimeoutError extends TimeoutError {
  constructor(popup) {
    super();
    this.popup = popup;
    Object.setPrototypeOf(this, PopupTimeoutError.prototype);
  }
}
class PopupCancelledError extends GenericError {
  constructor(popup) {
    super("cancelled", "Popup closed");
    this.popup = popup;
    Object.setPrototypeOf(this, PopupCancelledError.prototype);
  }
}
class PopupNotSupportedError extends GenericError {
  constructor(popup) {
    super(
      "NotSupported",
      "Popup window is blocked by browser. see: https://docs.joy.id/guide/best-practice#popup-window-blocked"
    );
    this.popup = popup;
    Object.setPrototypeOf(this, PopupCancelledError.prototype);
  }
}
const DEFAULT_AUTHORIZE_TIMEOUT_IN_SECONDS = 3e3;
const openPopup = (url = "") => {
  const width = 400;
  const height = 600;
  const left = window.screenX + (window.innerWidth - width) / 2;
  const top = window.screenY + (window.innerHeight - height) / 2;
  return window.open(
    url,
    "joyid:authorize:popup",
    `left=${left},top=${top},width=${width},height=${height},resizable,scrollbars=yes,status=1`
  );
};
const runPopup = (config) => new Promise((resolve, reject) => {
  if (isStandaloneBrowser()) {
    reject(new PopupNotSupportedError(config.popup));
  }
  let popupEventListener;
  let timeoutId;
  const popupTimer = setInterval(() => {
    if (config.popup && config.popup.closed) {
      clearInterval(popupTimer);
      clearTimeout(timeoutId);
      window.removeEventListener("message", popupEventListener, false);
      reject(new PopupCancelledError(config.popup));
    }
  }, 1e3);
  timeoutId = setTimeout(
    () => {
      clearInterval(popupTimer);
      reject(new PopupTimeoutError(config.popup));
      window.removeEventListener("message", popupEventListener, false);
    },
    (config.timeoutInSeconds || DEFAULT_AUTHORIZE_TIMEOUT_IN_SECONDS) * 1e3
  );
  popupEventListener = (e) => {
    var _a;
    const appURL = new URL(getConfig$1().joyidAppURL);
    if (e.origin !== appURL.origin) {
      return;
    }
    if (!e.data || ((_a = e.data) == null ? void 0 : _a.type) !== config.type) {
      return;
    }
    clearTimeout(timeoutId);
    clearInterval(popupTimer);
    window.removeEventListener("message", popupEventListener, false);
    config.popup.close();
    if (e.data.error) {
      reject(new Error(e.data.error));
    }
    resolve(e.data.data);
  };
  window.addEventListener("message", popupEventListener);
});
const styleId = "joyid-block-dialog-style";
const approveId = "joyid-block-dialog-approve";
const rejectId = "joyid-block-dialog-reject";
const styleSheet = `
.joyid-block-dialog {
  position: fixed;
  top: 32px;
  left: 50%;
  width: 340px;
  margin-left: -170px;
  background: white;
  color: #333;
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
  height: 110px;
  z-index: 100002;
  box-sizing: border-box;
  border: 1px solid #ffffff;
  border-radius: 8px;
  padding: 16px 20px;
}
.joyid-block-dialog-bg {
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,0.5);
  position: fixed;
  top: 0;
  left: 0;
  display: none;
  z-index: 100001;
  display: block;
}
.joyid-block-dialog-title {
  font-weight: bold;
  font-size: 14px;
  margin-bottom: 8px;
}
.joyid-block-dialog-tip {
  font-size: 12px;
  color: #777;
}
.joyid-block-dialog-btn {
  width: 90px;
  height: 35px;
  font-size: 12px;
  text-align: center;
  border-radius: 6px;
  cursor: pointer;
}
.joyid-block-dialog-action {
  text-align: right;
}
#${approveId} {
  border: 1px solid #333;
  color: #333;
  background: #D2FF00;
  margin-bottom: 8px;
}

#${rejectId} {
  background: transparent;
}
`;
const dialogInnerHtml = `
<div class="joyid-block-dialog">
  <div class="joyid-block-dialog-content">
    <div class="joyid-block-dialog-title">
      Request Pop-up
    </div>
    <div class="joyid-block-dialog-tip">
      Click Approve to complete creating or using wallet
    </div>
  </div>
  <div class="joyid-block-dialog-action">
    <button class="joyid-block-dialog-btn" id="${approveId}">Approve</button>
    <button class="joyid-block-dialog-btn" id="${rejectId}">Reject</button>
  </div>
</div>
`;
const appendStyle = () => {
  const _style = document.getElementById(styleId);
  if (_style) {
    return;
  }
  const style = document.createElement("style");
  style.appendChild(document.createTextNode(styleSheet));
  const head = document.head || document.getElementsByTagName("head")[0];
  head.appendChild(style);
};
const createBlockDialog = (cb) => {
  appendStyle();
  const dialog = document.createElement("div");
  dialog.innerHTML = dialogInnerHtml;
  document.body.appendChild(dialog);
  const dialogBg = document.createElement("div");
  dialogBg.className = "joyid-block-dialog-bg";
  document.body.appendChild(dialogBg);
  const approveBtn = document.getElementById(approveId);
  const rejectBtn = document.getElementById(rejectId);
  const closeDialog = () => {
    document.body.removeChild(dialog);
    document.body.removeChild(dialogBg);
  };
  return new Promise((resolve, reject) => {
    approveBtn == null ? void 0 : approveBtn.addEventListener("click", async () => {
      try {
        const data = await cb();
        closeDialog();
        resolve(data);
      } catch (error) {
        closeDialog();
        reject(error);
      }
    });
    rejectBtn == null ? void 0 : rejectBtn.addEventListener("click", () => {
      closeDialog();
      reject(new Error("User Rejected"));
    });
  });
};
const buildJoyIDSignMessageURL = (request, type) => buildJoyIDURL(request, type, "/sign-message");
const signMessageWithPopup = async (request, config) => {
  config = config || {};
  if (!config.popup) {
    config.popup = openPopup("");
    if (!config.popup) {
      return createBlockDialog(() => signMessageWithPopup(request, config));
    }
  }
  config.popup.location.href = buildJoyIDSignMessageURL(request, "popup");
  return runPopup({
    ...config,
    type: DappRequestType.SignMessage
  });
};
const buildJoyIDAuthURL = (request, type) => buildJoyIDURL(request, type, "/auth");
const authWithPopup = async (request, config) => {
  config = config || {};
  if (!config.popup) {
    config.popup = openPopup("");
    if (!config.popup) {
      return createBlockDialog(() => authWithPopup(request, config));
    }
  }
  config.popup.location.href = buildJoyIDAuthURL(
    request,
    DappCommunicationType.Popup
  );
  return runPopup({
    ...config,
    type: DappRequestType.Auth
  });
};
const payloadId = () => Date.now();
class Aggregator {
  constructor(url) {
    this.url = url;
  }
  async baseRPC(method, req, url = this.url) {
    const payload = {
      id: payloadId(),
      jsonrpc: "2.0",
      method,
      params: req ?? null
    };
    const body = JSON.stringify(payload, null, "");
    const data = await fetch(url, {
      method: "post",
      headers: {
        "Content-Type": "application/json"
      },
      body
    }).then((res) => res.json());
    if (data.error) {
      throw new Error(`RPC error: ${JSON.stringify(data.error)}`);
    }
    return data.result;
  }
  async generateSubkeyUnlockSmt(req) {
    return await this.baseRPC(
      "generate_subkey_unlock_smt",
      req
    );
  }
}
const TestnetInfo = {
  JoyIDLockScript: {
    codeHash: "0xd23761b364210735c19c60561d213fb3beae2fd6172743719eff6920e020baac",
    hashType: "type",
    args: ""
  },
  JoyIDLockDep: {
    outPoint: {
      txHash: "0x4dcf3f3b09efac8995d6cbee87c5345e812d310094651e0c3d9a730f32dc9263",
      index: "0x0"
    },
    depType: "depGroup"
  }
};
const MainnetInfo = {
  JoyIDLockScript: {
    codeHash: "0xd00c84f0ec8fd441c38bc3f87a371f547190f2fcff88e642bc5bf54b9e318323",
    hashType: "type",
    args: ""
  },
  JoyIDLockDep: {
    outPoint: {
      txHash: "0xf05188e5f3a6767fc4687faf45ba5f1a6e25d3ada6129dae8722cb282f262493",
      index: "0x0"
    },
    depType: "depGroup"
  }
};
const getJoyIDLockScript = (isMainnet) => isMainnet ? MainnetInfo.JoyIDLockScript : TestnetInfo.JoyIDLockScript;
const getJoyIDCellDep = (isMainnet) => isMainnet ? MainnetInfo.JoyIDLockDep : TestnetInfo.JoyIDLockDep;
const appendPrefix = (tokenKey) => {
  if (!tokenKey) {
    return tokenKey;
  }
  const key = remove0x(tokenKey);
  if (key.length === 48) {
    return `ffffffff${key}`;
  }
  return key;
};
const generateSignURL = (config, isCkb = true) => {
  const { joyidAppURL: __, joyidServerURL: _, ...ckbDappConfig } = config;
  const path = isCkb ? "/sign-ckb" : "/sign-cota-nft";
  const dappConfig = ckbDappConfig;
  if (!isCkb) {
    const tx = dappConfig.tx;
    tx.tokenKey = appendPrefix(tx.tokenKey);
    dappConfig.tx = tx;
  }
  return buildJoyIDURL(dappConfig, "popup", path);
};
const initConfig = (config) => {
  Object.assign(internalConfig, config);
  return internalConfig;
};
const getConfig = () => internalConfig;
const connect = async (config) => {
  config = {
    ...internalConfig,
    ...config
  };
  const res = await authWithPopup({
    redirectURL: location.href,
    ...config
  });
  return res;
};
const signChallenge = async (challenge, signerAddress, config) => {
  const isData = typeof challenge !== "string";
  config = {
    ...internalConfig,
    ...config
  };
  const res = await signMessageWithPopup({
    challenge: typeof challenge !== "string" ? bufferToHex(challenge) : challenge,
    isData,
    address: signerAddress,
    redirectURL: location.href,
    ...config
  });
  return res;
};
const signTransaction = async (tx, config) => {
  config = {
    ...internalConfig,
    ...config
  };
  if (!config.popup) {
    config.popup = openPopup("");
    if (!config.popup) {
      throw new Error(
        "Unable to open a popup for loginWithPopup - window.open returned `null`"
      );
    }
  }
  const { popup, timeoutInSeconds, ...dappConfig } = config;
  config.popup.location.href = generateSignURL({
    ...dappConfig,
    tx,
    signerAddress: tx.from,
    redirectURL: location.href
  });
  const res = await runPopup({
    timeoutInSeconds: timeoutInSeconds || 5e3,
    popup,
    type: DappRequestType.SignCkbTx
  });
  return res.tx;
};
const signCotaNFTTx = async (tx, config) => {
  config = {
    ...internalConfig,
    ...config
  };
  if (!config.popup) {
    config.popup = openPopup("");
    if (!config.popup) {
      throw new Error(
        "Unable to open a popup for loginWithPopup - window.open returned `null`"
      );
    }
  }
  const { popup, timeoutInSeconds, ...dappConfig } = config;
  config.popup.location.href = generateSignURL(
    {
      ...dappConfig,
      tx,
      signerAddress: tx.from,
      redirectURL: location.href
    },
    false
  );
  const res = await runPopup({
    timeoutInSeconds: timeoutInSeconds || 5e3,
    popup,
    type: DappRequestType.SignCotaNFT
  });
  return res.tx;
};
const signRawTransaction = async (tx, signerAddress, config) => {
  config = {
    ...tx,
    ...internalConfig,
    ...config
  };
  if (!config.popup) {
    config.popup = openPopup("");
    if (!config.popup) {
      throw new Error(
        "Unable to open a popup for loginWithPopup - window.open returned `null`"
      );
    }
  }
  const { popup, timeoutInSeconds, ...ckbDappConfig } = config;
  config.popup.location.href = buildJoyIDURL(
    {
      ...ckbDappConfig,
      tx,
      signerAddress,
      redirectURL: location.href
    },
    "popup",
    "/sign-ckb-raw-tx"
  );
  const res = await runPopup({
    timeoutInSeconds: timeoutInSeconds || 5e3,
    popup,
    type: DappRequestType.SignCkbRawTx
  });
  return res.tx;
};
export {
  Aggregator,
  connect,
  getConfig,
  getJoyIDCellDep,
  getJoyIDLockScript,
  initConfig,
  openPopup,
  signChallenge,
  signCotaNFTTx,
  signRawTransaction,
  signTransaction
};
